import React from 'react';
import { CheckCircle, Clock, AlertTriangle } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../ui/tooltip';

const SustainabilityBadge = ({ standard, status, description, lastAudit }) => {
  const getStatusColor = () => {
    switch (status) {
      case 'compliant':
        return 'bg-emerald-50 text-emerald-800 border-emerald-300';
      case 'pending':
        return 'bg-amber-50 text-amber-700 border-amber-300';
      case 'requires_review':
        return 'bg-rose-50 text-rose-700 border-rose-300';
      default:
        return 'bg-slate-50 text-slate-700 border-slate-300';
    }
  };

  const getStatusIcon = () => {
    switch (status) {
      case 'compliant':
        return <CheckCircle className="w-3 h-3 text-emerald-700" />;
      case 'pending':
        return <Clock className="w-3 h-3 text-amber-700" />;
      case 'requires_review':
        return <AlertTriangle className="w-3 h-3 text-rose-700" />;
      default:
        return null;
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-NO', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium border cursor-help ${getStatusColor()}`}
            data-testid={`sustainability-badge-${standard}`}
          >
            {getStatusIcon()}
            <span>{standard}</span>
          </div>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">
          <div className="space-y-1">
            <p className="font-semibold">{standard}</p>
            <p className="text-sm">{description}</p>
            {lastAudit && (
              <p className="text-xs text-slate-500">Last audit: {formatDate(lastAudit)}</p>
            )}
            <p className="text-xs font-medium mt-2">
              Status: <span className="capitalize">{status.replace('_', ' ')}</span>
            </p>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default SustainabilityBadge;
